import {
  SupportChannelList,
  SupportChannelSelection,
} from "@/components/internal-chats/support-channel-list";
import type { GroupChannel } from "@sendbird/chat/groupChannel";

interface ChatListProps {
  channels: GroupChannel[];
  loading: boolean;
  currentChannelUrl: string | null;
  onSelectChat: (selection: SupportChannelSelection) => void;
}

export const ChatList = ({
  channels,
  loading,
  currentChannelUrl,
  onSelectChat,
}: ChatListProps) => {
  return (
    <div className="h-full">
      <SupportChannelList
        channels={channels}
        loading={loading}
        currentChannelUrl={currentChannelUrl}
        onSelectChannel={onSelectChat}
      />
    </div>
  );
};
